import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }, null, -1)

import { computed, ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  /** Chỉ giữ số khi emit (mặc định true) */
  digitsOnly?: boolean;
  /** Độ dài tối đa số điện thoại VN */
  maxDigits?: number;
  validateOnBlur?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TelephoneInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập số điện thoại" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    digitsOnly: { type: Boolean, default: true },
    maxDigits: { default: 11 },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

const onlyDigits = (value: string) => value.replace(/\D/g, "").slice(0, props.maxDigits);

const formatPhone = (digits: string) => {
  if (!digits) return "";
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  if (digits.length <= 10) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}`;
};

const isValidPhone = (digits: string) => {
  if (!digits) return true;
  return /^(0[3|5|7|8|9])[0-9]{8}$|^01[2689][0-9]{8}$/.test(digits);
};

watch(
  () => props.modelValue,
  (val) => {
    const digits = onlyDigits(val ?? "");
    displayValue.value = formatPhone(digits);
  },
  { immediate: true }
);

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  const digits = onlyDigits(props.modelValue ?? "");
  return !!digits && !isValidPhone(digits);
});

const computedStatus = computed(() => {
  if (props.status) return props.status;
  return localError.value ? "error" : "";
});

const onInput = (val: string) => {
  const digits = onlyDigits(val);
  displayValue.value = formatPhone(digits);
  const emitValue = props.digitsOnly ? digits : displayValue.value;
  emit("update:modelValue", emitValue);
  emit("change", emitValue);
};

const onBlur = (e: FocusEvent) => {
  const digits = onlyDigits(props.modelValue ?? "");
  emit("validate", isValidPhone(digits));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxDigits,
    status: computedStatus.value,
    class: "ant-telephone-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status"]))
}
}

})